export const MAJESTIC_MAX_TOP_RANK = Number.MAX_VALUE;
export const NO_ANCHOR = '<empty anchor>';

// Turns the shared technical-error banner on for this tool.
export const TECHNICAL_ERROR_BANNER_ENABLED = false;
